import { apiClient } from './services/api-client';

export const rootDependencies = {
  apiClient,
};
export type RootDependencies = typeof rootDependencies;
